import { useEffect } from 'react'
import { useSettingsStore } from '../../store/settingsStore'
import { themes, type Theme } from '../../design/premiumTokens'

/**
 * Apply theme colors to CSS custom properties.
 * This allows theme colors to be used in CSS files via var(--theme-xxx)
 */
export function applyTheme(theme: Theme) {
  const root = document.documentElement
  const themeConfig = themes[theme]

  // Primary accent colors
  root.style.setProperty('--theme-primary', themeConfig.primary)
  root.style.setProperty('--theme-primary-hover', themeConfig.primaryHover)
  root.style.setProperty('--theme-primary-muted', themeConfig.primaryMuted)

  // Backgrounds
  root.style.setProperty('--theme-background', themeConfig.background)
  root.style.setProperty('--theme-card', themeConfig.card)
  root.style.setProperty('--theme-card-hover', themeConfig.cardHover)

  // Text colors
  root.style.setProperty('--theme-text', themeConfig.text)
  root.style.setProperty('--theme-text-secondary', themeConfig.textSecondary)
  root.style.setProperty('--theme-text-muted', themeConfig.textMuted)

  // Borders
  root.style.setProperty('--theme-border', themeConfig.border)
  root.style.setProperty('--theme-border-hover', themeConfig.borderHover)
  root.style.setProperty('--theme-overlay', themeConfig.overlay)

  // Buttons
  root.style.setProperty('--theme-button-primary', themeConfig.buttonPrimary)
  root.style.setProperty('--theme-button-primary-hover', themeConfig.buttonPrimaryHover)
  root.style.setProperty('--theme-button-secondary', themeConfig.buttonSecondary)
  root.style.setProperty('--theme-button-secondary-hover', themeConfig.buttonSecondaryHover)

  // Game UI chrome
  root.style.setProperty('--theme-round-indicator', themeConfig.roundIndicator)
  root.style.setProperty('--theme-phase-badge', themeConfig.phaseBadge)
  root.style.setProperty('--theme-active-player', themeConfig.activePlayer)
  root.style.setProperty('--theme-shadow', themeConfig.shadow)
}

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { theme } = useSettingsStore()

  useEffect(() => {
    applyTheme(theme)
  }, [theme])

  return <>{children}</>
}
